(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["funto-brand-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('funto-brand-motion')) {
    customElements.define('funto-brand-motion', class extends HTMLElement {
      connectedCallback() {
        this.canvas = this.querySelector('canvas');
        this.context = this.canvas?.getContext('2d');
        this.fw = Number(this.dataset.fw || this.canvas?.width);
        this.fh = Number(this.dataset.fh || this.canvas?.height);
        this.count = Number(this.dataset.count || 17);
        this.elapsed = -Number(this.dataset.delay || 0);
        this.ready = false;
        this.loading = false;
        this.visible = false;
        this.animation = null;
        this.lastTime = null;
        this.dataset.state = 'still';
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        if (this.dataset.kind === 'van') {
          this.driveX = 0;
          this.driveTarget = 0;
          this.driveAnimation = null;
          this.scrollY = window.scrollY;
          window.addEventListener('scroll', () => {
            const y = window.scrollY;
            const delta = y - this.scrollY;
            this.scrollY = y;
            if (!this.visible || document.hidden) return;
            if (this.updateHomeDrive()) { this.drive(); return; }
            const limit = window.matchMedia('(max-width: 749px)').matches ? 10 : 40;
            this.driveTarget = Math.max(-limit, Math.min(limit, this.driveTarget + Math.max(-80, Math.min(80, delta)) * 0.45));
            this.drive();
          }, { ...options, passive: true });
          window.addEventListener('resize', () => {
            if (this.updateHomeDrive()) { this.drive(); return; }
            const limit = window.matchMedia('(max-width: 749px)').matches ? 10 : 40;
            this.driveTarget = Math.max(-limit, Math.min(limit, this.driveTarget));
            this.drive();
          }, options);
          if (this.updateHomeDrive()) {
            this.driveX = this.driveTarget;
            this.style.setProperty('--van-offset', this.driveX.toFixed(2)+'px');
          }
        }
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.pause();
          else this.syncVisibility();
        }, options);
        if (!('IntersectionObserver' in window)) {
          this.visible = true;
          this.loadAtlas();
          this.resume();
          return;
        }
        this.preload = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.loadAtlas();
        }, { rootMargin: '200px' });
        this.observer = new IntersectionObserver(() => this.syncVisibility(), { threshold: 0, rootMargin:'32px' });
        this.preload.observe(this);
        this.observer.observe(this);
        const refresh = () => {
          if (this.visibilityRequest) return;
          this.visibilityRequest = requestAnimationFrame(() => { this.visibilityRequest = null; this.syncVisibility(); });
        };
        window.addEventListener('scroll', refresh, { ...options, passive:true });
        window.addEventListener('resize', refresh, options);
        window.addEventListener('pageshow', () => { this.pause(); refresh(); }, options);
        window.visualViewport?.addEventListener('resize', refresh, options);
        this.syncVisibility();
      }
      loadAtlas() {
        if (this.dataset.kind === 'van' || this.dataset.kind === 'cactus') return;
        if (this.loading || this.ready || !this.context || !this.dataset.atlas) return;
        this.loading = true;
        this.atlas = new Image();
        this.atlas.onload = () => {
          if (!this.isConnected) return;
          this.ready = true;
          this.preload?.disconnect();
          this.resume();
        };
        this.atlas.onerror = () => { this.dataset.state = 'floating'; };
        this.atlas.src = this.dataset.atlas;
      }
      showPoster() {
        if (this.canvas) this.canvas.hidden = true;
        this.removeAttribute('data-ready');
      }
      draw(frame) {
        if (String(frame) !== this.dataset.frame) {
          this.context.clearRect(0, 0, this.fw, this.fh);
          this.context.drawImage(this.atlas, (frame % 5) * this.fw, Math.floor(frame / 5) * this.fh, this.fw, this.fh, 0, 0, this.fw, this.fh);
          this.dataset.frame = String(frame);
        }
        this.canvas.hidden = false;
        this.setAttribute('data-ready', '');
      }
      syncVisibility() {
        if (!this.isConnected) return;
        const rect = this.getBoundingClientRect();
        this.visible = rect.width > 0 && rect.height > 0 && rect.bottom > -32 && rect.top < innerHeight+32 && rect.right > 0 && rect.left < innerWidth;
        if (this.visible && !document.hidden) { this.loadAtlas(); this.resume(); }
        else this.pause();
      }
      updateHomeDrive() {
        if (window.matchMedia('(max-width: 749px)').matches) {
          const heading = this.closest('.funto-film-heading-accent--van')?.closest('.funto-film-heading');
          if (!heading || !this.getBoundingClientRect().width) return false;
          const anchor = heading.getBoundingClientRect().bottom+window.scrollY;
          const from = anchor-innerHeight*.94;
          const to = anchor-innerHeight*.12;
          const progress = Math.max(0,Math.min(1,(window.scrollY-from)/Math.max(1,to-from)));
          this.driveTarget = -12+progress*24;
          return true;
        }
        if (!this.closest('.funto-film-accent--van')) return false;
        const stage = this.closest('.funto-film-stage');
        const media = stage?.querySelector('.funto-film-media');
        if (!stage || !media) return false;
        const rect = this.getBoundingClientRect();
        const video = media.getBoundingClientRect();
        if (!rect.width || !video.width) return false;
        const baseLeft = rect.left-this.driveX;
        const visibleLeft = baseLeft+rect.width*(72/280);
        const visibleRight = baseLeft+rect.width*(200/280);
        const finish = video.left-12-visibleRight;
        const begin = Math.min(finish,Math.max(16,Math.min(60,video.left*.12))-visibleLeft);
        const anchor = stage.getBoundingClientRect().bottom+window.scrollY-48;
        const from = anchor-innerHeight*.94;
        const to = anchor-innerHeight*.20;
        const progress = Math.max(0,Math.min(1,(window.scrollY-from)/Math.max(1,to-from)));
        this.driveTarget = begin+(finish-begin)*progress;
        return true;
      }
      drive() {
        if (this.driveAnimation !== null || !this.visible || document.hidden) return;
        const step = () => {
          this.driveAnimation = null;
          if (!this.isConnected || !this.visible || document.hidden) return;
          this.driveX += (this.driveTarget - this.driveX) * (this.closest('.funto-film-accent--van') && innerWidth > 749 ? 0.08 : 0.18);
          if (Math.abs(this.driveTarget - this.driveX) < 0.1) this.driveX = this.driveTarget;
          this.style.setProperty('--van-offset', this.driveX.toFixed(2) + 'px');
          if (this.driveX !== this.driveTarget) this.driveAnimation = requestAnimationFrame(step);
        };
        this.driveAnimation = requestAnimationFrame(step);
      }
      resume() {
        if (this.dataset.kind === 'van') { this.scrollY = window.scrollY; this.updateHomeDrive(); }
        const active = this.visible && !document.hidden;
        this.toggleAttribute('data-moving', active);
        if (active && this.dataset.kind === 'van') this.drive();
        if (!active || !this.ready || this.animation !== null) return;
        this.lastTime = null;
        this.animation = requestAnimationFrame(time => this.tick(time));
      }
      tick(time) {
        this.animation = null;
        if (!this.visible || document.hidden) return;
        if (this.lastTime !== null) this.elapsed += time - this.lastTime;
        this.lastTime = time;
        const duration = this.count * 1000 / 12;
        const phase = Math.max(0, this.elapsed) % (duration + 1800);
        if (this.elapsed < 0 || phase >= duration) {
          this.showPoster();
          this.dataset.state = 'floating';
        } else {
          this.draw(Math.min(this.count - 1, Math.floor(phase * 12 / 1000)));
          this.dataset.state = 'playing';
        }
        this.animation = requestAnimationFrame(next => this.tick(next));
      }
      pause() {
        cancelAnimationFrame(this.driveAnimation);
        this.driveAnimation = null;
        cancelAnimationFrame(this.animation);
        this.animation = null;
        this.lastTime = null;
        this.removeAttribute('data-moving');
        this.dataset.state = 'paused';
      }
      disconnectedCallback() {
        this.pause();
        cancelAnimationFrame(this.visibilityRequest);
        this.controller?.abort();
        this.observer?.disconnect();
        this.preload?.disconnect();
        if (this.atlas) { this.atlas.onload = null; this.atlas.onerror = null; }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["funto-gallery-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('funto-gallery-motion')) {
    customElements.define('funto-gallery-motion', class extends HTMLElement {
      connectedCallback() {
        this.canvas = this.querySelector('canvas');
        this.context = this.canvas?.getContext('2d');
        this.fw = Number(this.dataset.fw || this.canvas?.width);
        this.fh = Number(this.dataset.fh || this.canvas?.height);
        this.count = Number(this.dataset.count || 17);
        this.elapsed = -Number(this.dataset.delay || 0);
        this.ready = false;
        this.loading = false;
        this.visible = false;
        this.animation = null;
        this.lastTime = null;
        this.dataset.state = 'still';
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.pause();
          else this.resume();
        }, options);
        if (!('IntersectionObserver' in window)) {
          this.visible = true;
          this.loadAtlas();
          this.resume();
          return;
        }
        this.preload = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.loadAtlas();
        }, { rootMargin: '200px' });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) { this.loadAtlas(); this.resume(); }
          else this.pause();
        }, { threshold: 0.15 });
        this.preload.observe(this);
        this.observer.observe(this);
      }
      loadAtlas() {
        if (this.loading || this.ready || !this.context || !this.dataset.atlas) return;
        this.loading = true;
        this.atlas = new Image();
        this.atlas.onload = () => {
          if (!this.isConnected) return;
          this.ready = true;
          this.preload?.disconnect();
          this.resume();
        };
        this.atlas.onerror = () => { this.dataset.state = 'floating'; };
        this.atlas.src = this.dataset.atlas;
      }
      showPoster() {
        if (this.canvas) this.canvas.hidden = true;
        this.removeAttribute('data-ready');
      }
      draw(frame) {
        if (String(frame) !== this.dataset.frame) {
          this.context.clearRect(0, 0, this.fw, this.fh);
          this.context.drawImage(this.atlas, (frame % 5) * this.fw, Math.floor(frame / 5) * this.fh, this.fw, this.fh, 0, 0, this.fw, this.fh);
          this.dataset.frame = String(frame);
        }
        this.canvas.hidden = false;
        this.setAttribute('data-ready', '');
      }
      resume() {
        const active = this.visible && !document.hidden;
        this.toggleAttribute('data-moving', active);
        if (!active || !this.ready || this.animation !== null) return;
        this.lastTime = null;
        this.animation = requestAnimationFrame(time => this.tick(time));
      }
      tick(time) {
        this.animation = null;
        if (!this.visible || document.hidden) return;
        if (this.lastTime !== null) this.elapsed += time - this.lastTime;
        this.lastTime = time;
        const duration = this.count * 1000 / 12;
        const phase = Math.max(0, this.elapsed) % (duration + 1800);
        if (this.elapsed < 0 || phase >= duration) {
          this.showPoster();
          this.dataset.state = 'floating';
        } else {
          this.draw(Math.min(this.count - 1, Math.floor(phase * 12 / 1000)));
          this.dataset.state = 'playing';
        }
        this.animation = requestAnimationFrame(next => this.tick(next));
      }
      pause() {
        cancelAnimationFrame(this.animation);
        this.animation = null;
        this.lastTime = null;
        this.removeAttribute('data-moving');
        this.dataset.state = 'paused';
      }
      disconnectedCallback() {
        this.pause();
        this.controller?.abort();
        this.observer?.disconnect();
        this.preload?.disconnect();
        if (this.atlas) { this.atlas.onload = null; this.atlas.onerror = null; }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["funto-included-specs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('funto-included')) {
    customElements.define('funto-included', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('[id^="MainProduct-"]') || this.closest('.shopify-section');
        if (!this.scope) return;
        this.panels = Array.from(this.querySelectorAll('[data-included-variant]'));
        this.choices = this.panels.map(panel => ({ panel, options: JSON.parse(panel.dataset.options) }));
        this.onChange = event => {
          if (event.target.matches('sticky-atc select')) {
            const id = event.target.selectedOptions[0]?.dataset.variantId;
            this.show(this.panels.find(panel => panel.dataset.includedVariant === id));
            return;
          }
          const inPicker = event.target.closest('variant-selects');
          const inForm = event.target.name === 'id' && event.target.form?.id === this.dataset.formId;
          if (!inPicker && !inForm) return;
          queueMicrotask(() => this.sync());
        };
        this.scope.addEventListener('change', this.onChange);
        this.onBack = () => this.sync();
        window.addEventListener('popstate', this.onBack);
        this.sync();
      }
      disconnectedCallback() {
        this.scope?.removeEventListener('change', this.onChange);
        window.removeEventListener('popstate', this.onBack);
      }
      sync() {
        const picker = this.scope.querySelector('variant-selects');
        let selected;
        if (picker) {
          const options = Array.from(picker.querySelectorAll('.product-form__input')).map(group => {
            return group.querySelector('select')?.value ?? group.querySelector('input[type="radio"]:checked')?.value;
          });
          if (options.length && options.every(value => value !== undefined)) {
            selected = this.choices.find(choice => choice.options.length === options.length && choice.options.every((value, index) => value === options[index]))?.panel;
          }
        }
        if (!picker) {
          const form = document.getElementById(this.dataset.formId);
          const id = form?.querySelector('[name="id"]')?.value || this.dataset.initialVariant;
          selected = this.panels.find(panel => panel.dataset.includedVariant === id);
        }
        this.show(selected);
      }
      show(selected) {
        this.panels.forEach(panel => { panel.hidden = panel !== selected; });
        this.querySelector('[data-included-unavailable]').hidden = Boolean(selected);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
